import { selectHasManyOrgs } from "@app/organizations";
import { useSelector } from "@app/react";
import { orgPickerUrl, ssoDirectUrl } from "@app/routes";

import { useSsoRequiredBlock } from "../hooks";
import { AppSidebarLayout } from "../layouts";
import { Banner, Box, ButtonLink, Group, tokens } from "../shared";

export const SsoRequiredPage = () => {
  const { org } = useSsoRequiredBlock();
  const hasManyOrgs = useSelector(selectHasManyOrgs);

  return (
    <AppSidebarLayout>
      <div className="flex flex-col items-center text-center mt-16 mx-auto max-w-lg">
        <h1 className={tokens.type.h1}>SSO Login Required</h1>
        <Box className="mt-8 w-full text-left">
          <Group>
            <Banner variant="error">
              Sign in with SSO to continue accessing this organization.
            </Banner>

            <ButtonLink
              to={ssoDirectUrl(org.id)}
              className="font-semibold w-full"
            >
              Login with SSO
            </ButtonLink>

            {hasManyOrgs ? (
              <ButtonLink
                to={orgPickerUrl()}
                variant="white"
                className="font-semibold w-full"
              >
                Switch Organization
              </ButtonLink>
            ) : null}
          </Group>
        </Box>
      </div>
    </AppSidebarLayout>
  );
};
